module.exports = __webpack_public_path__ + "static/media/14.e8a4912d.jpg";